import React, { useState } from 'react';
import Student_Sidebar from '../component/Sidebar_student';
import '../assets/css/buttongradient.css';
const MatchQuiz = () => {
  const [questions, setQuestions] = useState([
    { id: 1, sentence: 'This is a sentence.', answer: '', options: ['Option 1', 'Option 2', 'Option 3'] },
    { id: 2, sentence: 'This is another sentence.', answer: '', options: ['Option 4', 'Option 5', 'Option 6'] },
    { id: 3, sentence: 'This is yet another sentence.', answer: '', options: ['Option 7', 'Option 8', 'Option 9'] },
    { id: 4, sentence: 'This is a different sentence.', answer: '', options: ['Option 10', 'Option 11', 'Option 12'] },
    { id: 5, sentence: 'This is the last sentence.', answer: '', options: ['Option 13', 'Option 14', 'Option 15'] }
  ]);
  const [draggedOption, setDraggedOption] = useState(null);

  const handleDragStart = (e, option) => {
    setDraggedOption(option);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, questionId) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        return { ...question, answer: draggedOption, options: question.options.filter((option) => option !== draggedOption) };
      }
      return question;
    });
    setQuestions(updatedQuestions);
    setDraggedOption(null);
  };

  const handleRemoveOption = (questionId) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        const removedOption = question.answer;
        const updatedOptions = [...question.options, removedOption].sort();
        return { ...question, answer: '', options: updatedOptions };
      }
      return question;
    });
    setQuestions(updatedQuestions);
  };

  const handleSubmit = () => {
    const correctAnswers = questions.filter((question) => question.answer === question.options[0]).length;
    const wrongAnswers = questions.length - correctAnswers;
    alert(`Correct Answers: ${correctAnswers}, Wrong Answers: ${wrongAnswers}`);
  };

  return (
<>
<div className="background-container">
    <div className="flex relative dark:bg-main-dark-bg">
        {/* Container for settings button */}
        <div className="fixed top-4 right-4 z-50">
          {/* Settings button content */}
        </div>

        {/* Sidebar */}
        <div className="w-72 fixed sidebar  bg-opacity-30 backdrop-blur-sm dark:bg-main-bg bg-main-bg min-h-screen">
          <Student_Sidebar />
        </div>

        <div className="ml-72 flex-1 dark:bg-main-dark-bg bg-main-bg min-h-screen">
          {/* Here is main content */}
    <div className="container mx-auto py-8">
      <div className="flex flex-wrap justify-center mb-8">
        {questions.flatMap((question) =>
          question.options.map((option) => (
            <div
              key={`${question.id}-${option}`}
              draggable
              onDragStart={(e) => handleDragStart(e, option)}
              className="border-solid border-2 border-indigo-600 rounded-md py-2 px-4 m-2 cursor-move text-gray-100"
            >
              {option}
            </div>
          ))
        )}
      </div>
      <div className="flex flex-col items-start">
        {questions.map((question) => (
          <div key={question.id} className="flex items-center mb-4">
            <div className=" border-2 border-indigo-600 p-3 rounded-lg mr-4 text-gray-100">
              {question.sentence}
            </div>
            <span className="mr-4 text-gray-100">→</span>
            <div
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, question.id)}
              className="border border-2-gray-300  rounded-md relative flex items-center text-gray-100"
            >
              <span className="mr-2 p-3">{question.answer || 'Drop here'}</span>
              {question.answer && (
                <button
                  onClick={() => handleRemoveOption(question.id)}
                  className="text-red-500 hover:text-red-700 focus:outline-none"
                >
                  &times;
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 flex justify-center">
        <button
          onClick={handleSubmit}
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded"
        >
          Submit
        </button>
      </div>
    </div>
    </div>
    </div>
    </div>
    </>
  );
  
};

export default MatchQuiz;